module.exports = __webpack_public_path__ + "img/success-icon.fb9ab12c.svg";